// Actions
export const INDEX_REQUEST: string = "Charts/INDEX_REQUEST";
export const INDEX_SUCCESS: string = "Charts/INDEX_SUCCESS";
export const INDEX_FAILURE: string = "Charts/INDEX_FAILURE";
